import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { useBooking } from "@/components/BookingProvider";

export const Eyebrow = ({ children, light, className = "" }) => (
  <span className={`eyebrow ${light ? "eyebrow-light" : ""} block mb-4 ${className}`}>{children}</span>
);

export const Rule = ({ className = "" }) => (
  <hr className={`border-0 border-t border-[#E2E8F0] ${className}`} />
);

const base =
  "group inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-medium tracking-wide transition-colors";

const styles = {
  accent: "bg-brand text-white hover:bg-brand-deep",
  dark: "bg-ink text-white hover:bg-ink-deep",
  ghost: "border border-[#CBD5E1] text-ink hover:border-ink hover:bg-white",
  light: "bg-white text-ink hover:bg-[#E2E8F0]",
  outlineLight: "border border-[#334155] text-white hover:bg-white hover:text-ink-deep",
};

export const BookButton = ({ label = "Book Strategy Call", variant = "accent", className = "", testId }) => {
  const { openBooking } = useBooking();
  return (
    <button data-testid={testId} onClick={openBooking} className={`${base} ${styles[variant]} ${className}`}>
      {label}
      <ArrowUpRight className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
    </button>
  );
};

export const RouteButton = ({ to, label, variant = "dark", className = "", testId }) => (
  <Link to={to} data-testid={testId} className={`${base} ${styles[variant]} ${className}`}>
    {label}
    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
  </Link>
);
